<template>
  <div class="about">
    <div class="hero is-primary">
      <div class="hero-body has-text-centered">
        <h1 class="title">About</h1>
      </div>
    </div>

    <section class="section">
      <div class="columns">
        <div class="column is-three-fifths is-offset-one-fifth">
          <p>
            MicroMastery is a specialized Learning Experience Platform (LXP)
            meticulously crafted to empower educators, institutions, and
            organizations in the realm of microcredentialing. This innovative
            platform is uniquely designed to provide a seamless and dynamic
            learning experience while focusing on the creation and management of
            microcredentials.
          </p>
          
          <br />

          <h2 class="title is-2">Key Features (Work in progress...)</h2>

          <div class="box">
            <p>
              <strong>Effortless Microcredential Creation</strong>
            </p>
            MicroMastery offers an intuitive and streamlined microcredential
            creation process. Educators and institutions can easily design,
            structure, and customize microcredentials that align with their
            specific learning objectives and competencies.
          </div>

          <br />

          <div class="box">
            <p><strong>Microcredential Variety</strong></p>
            <p>
              The platform is adaptable and accommodates various microcredential
              types, ranging from badges and certificates to digital credentials
              and nano-degrees. This adaptability ensures that learners have
              access to a diverse array of recognition for their
              accomplishments.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Competency-Based Learning Focus</strong></p>
            <p>
              MicroMastery places a strong emphasis on competency-based
              learning. It empowers educators to define and evaluate
              competencies within microcredentials, ensuring that learners gain
              specific skills and knowledge.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Robust Assessment Tools</strong></p>
            <p>
              The platform features a comprehensive assessment toolkit, enabling
              educators to create a wide range of assessments, including
              quizzes, projects, and performance evaluations. This ensures a
              rigorous evaluation of learners' skills and competencies.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Verified Microcredentials</strong></p>
            <p>
              MicroMastery provides secure and verifiable microcredentials.
              Employers and institutions can easily verify learners'
              achievements, enhancing the credibility and value of the
              microcredentials earned.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Progress Tracking and Analytical Insights</strong></p>
            <p>
              Educators can monitor learners' progress and assess their
              performance through detailed analytics and reporting tools. This
              data-driven approach supports continuous improvement in
              microcredential offerings.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Facilitating Collaboration and Peer Review</strong></p>
            <p>
              To foster collaboration and peer learning, MicroMastery includes
              features like discussion boards, peer review assessments, and
              collaborative projects within microcredential courses.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Mobile Accessibility</strong></p>
            <p>
              MicroMastery is fully responsive, ensuring that learners can
              access microcredential courses and content from any device. This
              promotes flexible and on-the-go learning.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Seamless Integration and Scalability</strong></p>
            <p>
              MicroMastery is scalable and supports integration with existing
              learning management systems (LMS) and third-party tools. This
              compatibility ensures smooth adoption within educational and
              organizational ecosystems.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Emphasis on Data Security and Privacy</strong></p>
            <p>
              MicroMastery places a high priority on data security and privacy,
              implementing robust measures to safeguard learner data and
              achievements.
            </p>
          </div>

          <br />

          <div class="box">
            <p><strong>Comprehensive Support and Training Resources</strong></p>
            <p>
              To assist educators and learners in leveraging the platform's
              capabilities, MicroMastery offers comprehensive customer support
              and training resources.
            </p>
          </div>

          <br />

          <p>
            In conclusion, MicroMastery is an innovative LXP tailored for the
            world of microcredentialing. It empowers educators, institutions,
            and organizations to effortlessly create, manage, and offer
            microcredentials that are competency-based, credible, and adaptable.
            With its user-friendly interface, robust features, and commitment to
            data-driven improvement, MicroMastery facilitates the delivery of
            high-value, industry-relevant microcredentials in today's education
            and professional development landscape.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = "About | MicroMastery";
  },
};
</script>
